<template>
  <div>
    <div class="header">
      <div class="logoBox">
        <img src="../../assets/newImg/logo.png" alt="" style="width:0.7rem;height:0.65rem">
        <h1 class="title">汇智衣服装制造全流程服务平台</h1>
      </div>
      <ul class="lilili" style="display: flex;gap: 0.5rem;justify-content: center;">
        <li>
          <router-link to="/index">{{$t('meg.home')}}</router-link>
        </li>
        <li>
          <router-link to="/Introduction">{{$t('meg.introduction')}}</router-link>
        </li>
        <li>
          <router-link to="/product">{{$t('meg.Product')}}</router-link>
        </li>
        <li>
          <router-link to="/factory">{{$t('meg.factory')}}</router-link>
        </li>
        <li>
          <router-link to="/news">{{$t('meg.news')}}</router-link>
        </li>
        <li>
          <router-link to="/Entering">{{$t('meg.Entering')}}</router-link>
        </li>
      </ul>
      <div class="loginBox" style="margin-right: 0.22rem;">
        <span style="margin-right: 0.2rem;" @click="changelang" v-if="i18n.locale.value == 'zh'">EN</span>
        <span style="margin-right: .25rem;" @click="changelang" v-if="i18n.locale.value == 'en'">中</span>
        <div style="display: inline-block;">
          <span v-if="access_token" style="margin-right: .375rem;vertical-align: super;"> {{$t('meg.welcome')}},{{ userName }}</span>
          <el-dropdown v-if="access_token"  style="border: none;">
            <span @click="personClick('')" class="el-dropdown-link" style="outline: none;">
              {{$t('meg.person')}}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <div
                style="width: 3.8875rem;padding:.3rem; background: #FFFFFF;border-radius: 0rem 0rem 0rem 0rem;opacity: 1;border: .0125rem solid #DDDDDD;">
                <div style="margin-top: 20px;display: flex;justify-content: space-around;">
                  <span
                    style="margin-top: .125rem;font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">{{$t('meg.ACCOUNT')}}</span>
                  <el-button class="logoout" @click="logoutBtn">{{$t('meg.logoout')}}</el-button>
                </div>
                <div
                  style="margin-top: .35rem;margin-left: .375rem;font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">
                  {{$t('meg.welcome')}} {{ userName }}</div>
                <hr style="margin-top: .175rem;margin-left: .375rem;margin-right: .375rem;">
                <el-dropdown-menu style="margin-left: .2rem;">
                  <el-dropdown-item @click="personClick(1)">{{$t('meg.personal')}}</el-dropdown-item>
                  <el-dropdown-item @click="personClick(2)">{{$t('meg.myOrder')}}</el-dropdown-item>
                  <el-dropdown-item @click="personClick(3)">{{$t('meg.MyCollection')}}</el-dropdown-item>
                  <!-- <el-dropdown-item>消息通知</el-dropdown-item> -->
                </el-dropdown-menu>
              </div>
            </template>
          </el-dropdown>
        </div>
        <span @click="loginBtn" v-if="!access_token"> {{$t('meg.login')}}</span>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <el-dialog v-model="loginDialog" :before-close="handleClose" class="loginDialog">
      <div style="display: flex;justify-content: space-around;">
        <div>
          <div class="loginTitle">{{$t('meg.userlogin')}}</div>
          <div class="login_form">
            <div style="margin-left: .875rem;">
              <el-form :model="loginForm" :rules="loginRules">
                <el-form-item prop="userName" style="margin-bottom: .3125rem;">
                  <el-input v-model="loginForm.userName" :placeholder="$t('meg.userName')" class="input"
                    :prefix-icon="User">
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input show-password type="password" v-model="loginForm.password" :placeholder="$t('meg.Password')"
                    class="input" :prefix-icon="Lock">
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <p style="font-size: .15rem;font-family: PingFang SC, PingFang SC;font-weight: 400;color: #333333;margin-top: .25rem; text-align: right;cursor: pointer;"
              @click="forgetBtn">{{ $t('meg.forgotpassword') }}</p>
            <el-button class="loginBtn" @click="loginclick">{{ $t('meg.loginBtn') }}</el-button>
          </div>
        </div>
        <div style="margin-left: .9125rem;margin-right: .725rem;">
          <div class="register">{{ $t('meg.resgister') }}</div>
          <p class="registerTip">{{ $t('meg.progress') }}</p>
          <!-- <el-button class="registerBtn" @click="registerBtn">立即注册</el-button> -->
          <el-button class="registerBtn" @click="registerBtn">{{ $t('meg.customer') }}</el-button>
          <el-button class="registerBtn" @click="factBtn" style="margin-left: 0;">{{ $t('meg.manufacturer') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 注册弹窗 -->
    <el-dialog v-model="registerDialog" :before-close="handleClose" class="registerDialog">
      <h1 class="reg">{{ $t('meg.resgisteruser') }}&nbsp;<span style="text-decoration: underline;cursor: pointer;" @click="logBtn">{{ $t('meg.logBtn') }}</span>
      </h1>
      <div class="regForm">
        <el-form :inline="true" label-width="1.7rem" label-position="center" :rules="rules" :model="registerForm">
          <el-form-item prop="useName" :label="$t('meg.user')" required>
            <el-input v-model="registerForm.useName" />
          </el-form-item>
          <el-form-item :label="$t('meg.tephone')" required prop="phone" style="margin-left: .5rem;">
            <el-input v-model="registerForm.phone" />
          </el-form-item>
          <el-form-item prop="password" :label="$t('meg.password')" required>
            <el-input type="password" v-model="registerForm.password" />
          </el-form-item>
          <el-form-item :label="$t('meg.confirmPassword')" required prop="confirmPassword" style="margin-left: .5rem;">
            <el-input type="password" v-model="registerForm.confirmPassword" />
          </el-form-item>
          <el-form-item :label="$t('meg.email')" required prop="email">
            <el-input v-model="registerForm.email" />
          </el-form-item>
          <el-form-item :label="$t('meg.code')" required prop="code" style="margin-left: .4375rem;">
            <el-input style="width: 1.7rem;" v-model="registerForm.code" />
            <el-button @click="sendVerificationCode" :disabled="!canSendCode" class="yanzhengBtn">{{
              canSendCode ? '发送验证码' :
              `重新发送(${countdown}s)` }}</el-button>
          </el-form-item>
          <!-- <el-form-item prop="userType" label="客户类型" required>
            <el-select v-model="registerForm.userType" class="m-2" placeholder="请选择客户类型" size="large"
              style="width: 240px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('meg.contacts')" required prop="contacts" style="margin-left: 0;">
            <el-input v-model="registerForm.contacts" />
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: .75rem;">
        <el-button class="registerBtn" @click="regBtn" style="margin-top: 0;">{{ $t('meg.customer') }}</el-button>
      </div>
    </el-dialog>
    
    <!-- 生产商注册弹窗 -->
      <el-dialog v-model="factDialog" :before-close="handleClose" class="registerDialog">
      <h1 class="reg">{{ $t('meg.resgisteruser') }}&nbsp;<span style="text-decoration: underline;cursor: pointer;" @click="logBtn">{{ $t('meg.logBtn') }}</span>
      </h1>
      <div class="regForm">
        <el-form :inline="true" label-width="1.7rem" label-position="center" :rules="rules" :model="registerForm">
          <el-form-item prop="useName" :label="$t('meg.user')" required>
            <el-input v-model="registerForm.useName" />
          </el-form-item>
          <el-form-item :label="$t('meg.tephone')" required prop="phone" style="margin-left: .5rem;">
            <el-input v-model="registerForm.phone" />
          </el-form-item>
          <el-form-item prop="password" :label="$t('meg.password')" required>
            <el-input type="password" v-model="registerForm.password" />
          </el-form-item>
          <el-form-item :label="$t('meg.confirmPassword')" required prop="confirmPassword" style="margin-left: .5rem;">
            <el-input type="password" v-model="registerForm.confirmPassword" />
          </el-form-item>
          <el-form-item :label="$t('meg.email')" required prop="email">
            <el-input v-model="registerForm.email" />
          </el-form-item>
          <el-form-item :label="$t('meg.code')" required prop="code" style="margin-left: .4375rem;">
            <el-input style="width: 1.7rem;" v-model="registerForm.code" />
            <el-button @click="sendVerificationCode" :disabled="!canSendCode" class="yanzhengBtn">{{
              canSendCode ? '发送验证码' :
              `重新发送(${countdown}s)` }}</el-button>
          </el-form-item>
          <!-- <el-form-item prop="userType" label="客户类型" required>
            <el-select v-model="registerForm.userType" class="m-2" placeholder="请选择客户类型" size="large"
              style="width: 240px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item> -->
          <el-form-item label="联系人" required prop="contacts" style="margin-left: 0;">
            <el-input v-model="registerForm.contacts" />
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: .75rem;">
        <el-button class="registerBtn" @click="factReg" style="margin-top: 0;">{{ $t('meg.manufacturer') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { Search, User, Lock, ArrowDown } from '@element-plus/icons-vue'
import { onMounted, ref, reactive, computed, watch,provide } from 'vue'
import { useRouter } from 'vue-router';
import { login, register, selectUserName, sendCode, regFactory,logoout,selectPhonenumer } from "@/api/login.js"
import { ElMessage,ElMessageBox } from 'element-plus'
import { useI18n } from 'vue-i18n';

const loginDialog = ref(false)
const roleType = ref("")
const registerDialog = ref(false)
const factDialog = ref(false)
const canSendCode = ref(true)
const countdown = ref(60)
const isUserName = ref("")
const isPhone = ref("")
const userName = localStorage.getItem('userName')
const access_token = localStorage.getItem('access_token')
const i18n = useI18n()
const selectedLanguage = localStorage.getItem('selectedLanguage') || 'zh'; // 从本地存储中获取语言，默认为中文


onMounted(() => {
  // 设置语言
  i18n.locale.value = selectedLanguage;
})

const personClick = (val) => {
  localStorage.setItem('type',val)
  router.push("/person")
}

const openModal = () => {
  loginDialog.value = true
}
// 子组件默认包含是私有
defineExpose({
  openModal
})  
const changelang = () => {
  i18n.locale.value == 'zh' ? i18n.locale.value = 'en' : i18n.locale.value = 'zh'
  localStorage.setItem('selectedLanguage', i18n.locale.value);
}

// const language = localStorage.getItem("selectedLanguage")

const router = useRouter()
const show = ref(false)
const homeShow = ref(true)


const forgetBtn = () => {
  router.push("/forgerpassword")
}

const loginclick = () => {
  let obj = {
    username: loginForm.userName,
    password: loginForm.password
  }
  login(obj).then(res => {
    if (res.data.code == 200) {
      const token = res.data.data.access_token
      const userName = res.data.data.loginUser.username
      roleType.value = res.data.data.loginUser.sysUser.roles[0].roleType
      loginDialog.value = false
      if (roleType.value == 0) {
        ElMessage.error("您没有权限，请去注册")
        return
      }
      localStorage.setItem('access_token', token);
      localStorage.setItem('userName', userName);
      localStorage.setItem('roleType', roleType.value);
      location.reload();
    } else {
      ElMessage.error(res.data.msg)
      return
    }
  })
}

const loginForm = reactive({
  userName: "",
  password: ""
})
const loginRules = reactive({
  userName: [
    { required: true, trigger: "blur", message: "用户名不能为空" },
    { max: 30, message: "用户名最大不能超过30位", trigger: "blur" },
  ],
  password: [
    { required: true, trigger: "blur", message: "密码不能为空" }
  ],
  // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
  code: [],
})
const loginBtn = () => {
  // router.push("/login")
  loginDialog.value = true
}

const personBtn = () => {
  router.push("/person")
}

const logoutBtn = () => {
    ElMessageBox.confirm(
    '确定注销并退出系统吗？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
     logoout().then(res => {
        if(res.data.code == 200) {
          localStorage.removeItem("access_token")
          router.push("/index")
          setTimeout(() => {
            location.reload();
          },1000)
        }
    })
    })
   
}
const registerBtn = () => {
  resetRegisterForm()
  loginDialog.value = false
  registerDialog.value = true
}

const factBtn = () => {
  resetRegisterForm()
  loginDialog.value = false
  factDialog.value = true
}

const registerForm = reactive({
  useName: "",
  password: "",
  confirmPassword: "",
  phone: "",
  email: "",
  code: "",
  contacts: "",
  userType: "",
})
const options = [
  {
    value: '1',
    label: '客户',
  },
  {
    value: '2',
    label: '生产商',
  },
]
const acctoken = ref(localStorage.getItem("access_token"))


const validateConfirmPassword = async (rule, value) => {
  if (value !== registerForm.password) {
    throw new Error('两次输入密码不一致');
  }
};

const rules = {
  useName: [{ required: true, message: '请输入用户名', trigger: 'blur' },
  {
    validator: async (rule, value) => {
      // Check if the username already exists
      const response = await selectUserName(value);
      isUserName.value = ""
      if (response.data.code === 500) {
        isUserName.value = response.data.msg
        return Promise.reject(response.data.msg);
      } else {
        return Promise.resolve();
      }
    },
    trigger: 'blur'
  }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少为6位', trigger: 'blur' },
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    { validator: validateConfirmPassword, trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    {
      pattern: /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
      message: '请输入正确的手机号',
      trigger: 'blur',
    },
    {
    validator: async (rule, value) => {
      // Check if the username already exists
      const response = await selectPhonenumer(value);
      isPhone.value = ""
      if (response.data.code == 400) {
        isPhone.value = response.data.msg
        return Promise.reject(response.data.msg);
      } else {
        return Promise.resolve();
      }
    },
    trigger: 'blur'
  }
  ],
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    {
      pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      message: '请输入正确的邮箱格式',
      trigger: 'blur',
    },
  ],
  // userType: [
  //   { required: true, message: '请选择客户类型', trigger: 'change' }
  // ],
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
  contacts: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
  // compantName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
  // country: [{ required: true, message: '请选择所属国家', trigger: 'change' }],
  // contactInformation: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
  // companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }]
};
const sendVerificationCode = () => {
  // 检查是否输入了邮箱
  if (!registerForm.email) {
    ElMessage.warning('请先输入邮箱');
    return;
  }
  sendCode({ email: registerForm.email }).then(res => {
    if (res.data.code == 200) {
      ElMessage.success('发送验证码成功');
      // 启动倒计时
      canSendCode.value = false;
      const timer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(timer);
          canSendCode.value = true;
          countdown.value = 60;
        }
      }, 1000);
    } else {
      ElMessage.error(res.data.msg);
      return
    }
  })

}

const resetRegisterForm = () => {
  registerForm.useName = "";
  registerForm.password = "";
  registerForm.confirmPassword = "";
  registerForm.phone = "";
  registerForm.email = "";
  registerForm.code = "";
  registerForm.contacts = "";
  registerForm.userType = "";
};


const regBtn = () => {
  if(isUserName.value == '用户名已存在') {
    ElMessage.error('用户名已存在');
    return
  }
  if(isPhone.value == '手机号码已存在') {
    ElMessage.error('手机号码已存在');
    return
  }
  // 检查是否有必填字段为空
  const emptyFields = Object.keys(registerForm).filter(
    key => rules[key] && rules[key].some(rule => rule.required) && !registerForm[key]
  );

  if (emptyFields.length > 0) {
    // 有必填字段为空，提示用户并阻止注册
    ElMessage.error('请填写所有必填字段');
    return;
  }
  // if (!registerForm.logo) {
  //     ElMessage.error('请上传公司logo');
  //     return
  // }
  let obj = {
    userName: registerForm.useName,
    password: registerForm.password,
    phonenumber: registerForm.phone,
    email: registerForm.email,
    code: registerForm.code,
    contacts: registerForm.contacts
  }
  register(obj).then(res => {
    if (res.data.code == 200) {
      ElMessage({
        message: '注册成功',
        type: 'success',
      })
      resetRegisterForm()
      registerDialog.value = false
      factDialog.value = false
      loginDialog.value = true
    } else {
      ElMessage.error(res.data.msg)
    }
  })
}

const logBtn = () => {
  registerDialog.value = false
  loginDialog.value = true
  factDialog.value = false
}

const factReg = () => {
  if(isUserName.value == '用户名已存在') {
    ElMessage.error('用户名已存在');
    return
  }
  if(isPhone.value == '手机号码已存在') {
    ElMessage.error('手机号码已存在');
    return
  }
  // 检查是否有必填字段为空
  const emptyFields = Object.keys(registerForm).filter(
    key => rules[key] && rules[key].some(rule => rule.required) && !registerForm[key]
  );

  if (emptyFields.length > 0) {
    // 有必填字段为空，提示用户并阻止注册
    ElMessage.error('请填写所有必填字段');
    return;
  }

  // if (!registerForm.logo) {
  //     ElMessage.error('请上传公司logo');
  //     return
  // }
  let obj = {
    userName: registerForm.useName,
    password: registerForm.password,
    phonenumber: registerForm.phone,
    email: registerForm.email,
    code: registerForm.code,
    contacts: registerForm.contacts
  }
  regFactory(obj).then(res => {
    if (res.data.code == 200) {
      ElMessage({
        message: '注册成功',
        type: 'success',
      })
      resetRegisterForm()
      registerDialog.value = false
      factDialog.value = false
      loginDialog.value = true
    } else {
      ElMessage.error(res.data.msg)
    }
  })
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 0.94rem;
  border-bottom: 0.01rem solid #DDDDDD;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  z-index: 99;
}

.logoBox {
  padding-left: 0.46rem;
  padding-top: 0.14rem;
  display: flex;
}

.title {
  font-size: 0.3rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 0.65rem;
  margin-left: 0.24rem;
}

.loginBox{
  display:flex;
}
.loginBox span {
  font-size: 0.16rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 1.0625rem;
  cursor: pointer;

}

.lilili li {
  font-size: 0.16rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 0.94rem;
  cursor: pointer;
}

.lilili li a {
  font-size: 0.16rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  padding-bottom: 0.14rem;
}

.menuBox {
  height: 1.15rem;
  background-color: #fff;
}

.menuBox li {
  line-height: 1.15rem;
}

.menuBox li a {
  font-size: .2rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  padding-bottom: .175rem;
}

#nav a.router-link-exact-active {
  font-weight: 700;
  border-bottom: 0.02rem solid #467DEF;
}

::v-deep .loginDialog {
  width: 10.625rem;
  /* height: 7.5875rem; */
  background: #FFFFFF;
  border-radius: 0rem 0rem 0rem 0rem;
  opacity: 1;
  padding-bottom: .75rem;
}

::v-deep .el-dialog__close {
  font-size: .2375rem;
  color: #000000;
  opacity: 1;
}

.loginTitle {
  font-size: .3rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  margin-left: .875rem;
  text-align: left;
  margin-top: .625rem;
}

.login_form {
  /* width: 350px; */
  /* height: 353px; */
  box-sizing: border-box;
  opacity: 1;
  /* overflow: hidden; */
  padding-bottom: .3375rem;
  margin-top: .3875rem;
}

.input {
  width: 4.2125rem;
  height: .8rem;
  background: #FFFFFF;
  opacity: 1;
  border: .0125rem solid #D8D8D8;
}

::v-deep .el-input__icon {
  font-size: .25rem;
}

.loginBtn {
  width: 4.2125rem;
  height: .8rem;
  background: #002FA7;
  opacity: 1;
  font-size: .2375rem;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  margin-left: .875rem;
  margin-top: .2625rem;
}

.register {
  text-align: left;
  font-size: .3rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  margin-top: .625rem;
}

.registerTip {
  margin-top: .35rem;
  text-align: left;
  font-size: .175rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 700;
  color: #000000;
}

.registerBtn {
  width: 4.2125rem;
  height: .8rem;
  background: #002FA7;
  opacity: 1;
  font-size: .2375rem;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .35rem;
}

::v-deep .registerDialog {
  width: 11.775rem;
  /* height: 7.775rem; */
  background: #FFFFFF;
  opacity: 1;
  overflow: hidden;
  padding-bottom: .25rem;
}

.reg {
  font-size: .175rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 700;
  color: #000000;
  text-align: left;
  margin-top: .125rem;
}

.regForm {
  margin-top: .375rem;
}

.regForm ::v-deep .el-form {
  display: flex;
  flex-wrap: wrap;
}

.regForm ::v-deep .el-input {
  width: 3.2875rem;
  height: .65rem;
  background: #FFFFFF;
  opacity: 1;
  border: .0125rem solid #D8D8D8;
}

.regForm ::v-deep .el-form-item__label {
  font-size: .175rem;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #333333;
  /* line-height: .65rem; */
}

.regForm ::v-deep .el-form-item {
  margin-top: .4375rem;
}

.yanzhengBtn {
  width: 1.425rem;
  height: .65rem;
  background: #002FA7;
  opacity: 1;
  border: .0125rem solid #D8D8D8;
  font-size: .225rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  margin-left: .3125rem;
}

.logoout {
  width: 1.425rem;
  height: .4875rem;
  background: #818AA0;
  opacity: 1;
  border: .0125rem solid #D8D8D8;
  font-size: .225rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
}
::v-deep .el-dropdown-menu__item {
    font-size: .2rem;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      color: #000000;
      margin-top: .125rem;
}
::v-deep .el-dropdown:hover {
  border: none;
}
::v-deep .el-dropdown-link:hover {
  border: none;
}
::v-deep .el-input__inner::placeholder {
  font-size: .175rem;
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-form--inline .el-form-item {
  margin-right: .4rem;
}

::v-deep .el-input__inner {
  font-size: .175rem;
}

::v-deep .el-form-item__error {
  font-size: .15rem;
}

</style>
